export const REQUEST_TRACKER_TRANSACTIONS = 'REQUEST_TRACKER_TRANSACTIONS';
export const RECEIVED_TRACKER_TRANSACTIONS_SUCCESS = 'RECEIVED_TRACKER_TRANSACTIONS_SUCCESS';
export const RECEIVED_TRACKER_TRANSACTIONS_ERROR = 'RECEIVED_TRACKER_TRANSACTIONS_ERROR';

// OMNI CHANNEL ACTIONS
export const RECEIVED_OCP_DATA = 'RECEIVED_OCP_DATA';
export const OCP_PROMPT_CLICKED = 'OCP_PROMPT_CLICKED';
export const RESET_OMNI_CHANNEL_PROMPT_INFO = 'RESET_OMNI_CHANNEL_PROMPT_INFO';
